import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { AlertContent, Input, ModalFactory } from 'components';
import { selectIsLoadingAPIRequest } from 'store/ApiClient';
import { LaborReview as LaborReviewActionTypes, restoreLaborRequest } from 'store/LaborReview';
import { IStore } from 'store/types';
import { ILabor } from 'types';
import { OverrideReasonCallout } from './OverrideReasonCallout';
import { alertFooterButtonStyles, RequiredField } from './styles';
import { REASON_MAX_LENGTH, REASON_TOO_LONG_MESSAGE } from './utils';

const StyledAlertContent = styled(AlertContent)`
  ${alertFooterButtonStyles}
`;

interface IRestoreShiftModalProps {
  siteId: string;
  date: string;
  locationId: string;
  employeeId: string;
  employeeName?: string;
  labor: ILabor;
  onClose: () => void;
}

export const RestoreShiftModal: React.FC<IRestoreShiftModalProps> = ({ siteId, date, locationId, employeeId, employeeName, labor, onClose }) => {
  const dispatch = useDispatch();
  const isRestoring = useSelector((state: IStore) => selectIsLoadingAPIRequest(state, LaborReviewActionTypes.RESTORE_LABOR_REQUEST));
  const [reason, setReason] = useState('');
  const isReasonTooLong = reason.trim().length > REASON_MAX_LENGTH;

  const handleRestore = () => {
    dispatch(restoreLaborRequest(siteId, date, locationId, employeeId, { version: labor.version, reason: reason.trim() }, onClose));
  };

  return (
    <ModalFactory customModal onClose={onClose} isActive>
      <StyledAlertContent
        title="Restore original clock times?"
        message={`This discards the manual correction for ${employeeName || `#${employeeId}`} and restores the clock times Legion sent.`}
        leftActionLabel="Cancel"
        rightActionLabel="Restore Legion data"
        onClose={onClose}
        onLeftAction={onClose}
        onRightAction={handleRestore}
        isLoading={isRestoring}
        disabled={!reason.trim() || isReasonTooLong}
        maxWidth={566}
        centerButtons
      >
        <OverrideReasonCallout overridden={labor.overridden} label="Reason given for the current correction" />

        <RequiredField label="Reason for restoring" message={isReasonTooLong ? REASON_TOO_LONG_MESSAGE : ''} hasError={isReasonTooLong}>
          <Input placeholder="Add a reason for restoring" value={reason} onChange={(e) => setReason(e.target.value)} data-cy="restore-reason" />
        </RequiredField>
      </StyledAlertContent>
    </ModalFactory>
  );
};
